import { defineAsyncComponent as t } from "vue";
const o = {
  MsButton: t(() => import("./index148.js")),
  MsHeader: t(() => import("./index163.js")),
  MsFooter: t(() => import("./index158.js")),
  MsSmartBanner: t(() => import("./index189.js")),
  MsBackToTopButton: t(() => import("./index143.js")),
  M_Link_List: t(() => import("./index105.js")),
  MsMarktjagdIframe: t(
    () => import("./index179.js")
  ),
  ETable: t(() => import("./index81.js")),
  MChart: t(() => import("./index95.js")),
  RelocationForm: t(
    () => import("./index196.js")
  ),
  MsIframe: t(() => import("./index171.js")),
  MsFooterSEOLinkList: t(
    () => import("./index162.js")
  ),
  HydratedQuestionStar: t(
    () => import("./index219.js")
  ),
  HydratedLinkList: t(
    () => import("./index220.js")
  ),
  HydratedChart: t(() => import("./index221.js")),
  HydratedQuestionStarSticky: t(
    () => import("./index222.js")
  ),
  CsExpandableLinkList: t(
    () => import("./index21.js")
  ),
  StageRelocationForm: t(
    () => import("./index223.js")
  ),
  HydratedStickyTeaser: t(
    () => import("./index224.js")
  ),
  HydratedAppModal: t(() => import("./index225.js")),
  HydratedLPModal: t(() => import("./index226.js")),
  CsEventsSlider: t(() => import("./index227.js"))
};
export {
  o as dynamicImports
};
